/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Access_Emailonly3Inputs */

const en_coinvestments_draftemail_access_emailonly3 = /** @type {(inputs: Coinvestments_Draftemail_Access_Emailonly3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email only — not a platform user`)
};

/**
* | output |
* | --- |
* | "email only — not a platform user" |
*
* @param {Coinvestments_Draftemail_Access_Emailonly3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_access_emailonly3 = /** @type {((inputs?: Coinvestments_Draftemail_Access_Emailonly3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Access_Emailonly3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_access_emailonly3(inputs)
});
export { coinvestments_draftemail_access_emailonly3 as "coInvestments_draftEmail_access_emailOnly" }